import React from 'react';
import { CertificateStatus } from '@/types/certificate';
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
  MinusCircleIcon,
} from '@heroicons/react/24/solid';
import Icon from '@/components/ui/AppIcon';


interface StatusBadgeProps {
  status: CertificateStatus;
  size?: 'sm' | 'md' | 'lg';
}

const config: Record<CertificateStatus, { className: string; Icon: React.ElementType; label: string }> = {
  Active: {
    className: 'badge-active',
    Icon: CheckCircleIcon,
    label: 'Valid / Active',
  },
  'Expiring Soon': {
    className: 'badge-expiring',
    Icon: ExclamationTriangleIcon,
    label: 'Expiring Soon',
  },
  Expired: {
    className: 'badge-expired',
    Icon: XCircleIcon,
    label: 'Expired',
  },
  Revoked: {
    className: 'badge-revoked',
    Icon: MinusCircleIcon,
    label: 'Revoked',
  },
};

export default function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const { className, Icon, label } = config[status] ?? config['Active'];
  const iconSize = size === 'lg' ? 'w-4 h-4' : 'w-3 h-3';
  const textSize = size === 'lg' ? 'text-sm px-3 py-1.5' : '';

  return (
    <span className={`${className} ${textSize}`}>
      <Icon className={iconSize} />
      {label}
    </span>
  );
}